export default __webpack_public_path__ + "static/media/LinkedIn-Like.0442269c.png";